import styled from 'styled-components';
import { th } from '@yoweb/ui/styles/utils/theme';
import { jsx as _jsx } from "react/jsx-runtime";
export var TextSeperator = function TextSeperator(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_jsx(TextSeperatorRoot, {
    children: text
  });
};
var TextSeperatorRoot = styled.div.withConfig({
  componentId: "sc-15fi28n-0"
})(["display:flex;text-align:center;align-items:center;text-transform:uppercase;color:", ";font-size:", ";font-weight:", ";&::before,&::after{content:'';flex:1;border-bottom:1.5px solid ", ";}&::before{margin-right:", ";}&::after{margin-left:", ";}"], th.getColor('charcoal'), th.getFontSize('bodySm'), th.getFontWeight('bold'), th.getColor('sandDark'), th.getSpace('normal1'), th.getSpace('normal1'));